"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_face__recognition__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "7725295b-51bf-4e2f-9b1d-aaa4c3983088",
    x1: 96.71,
    y1: 172.66,
    x2: 94.92,
    y2: -45.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e9e9e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f1c81ed0-752c-4f39-89b6-2ac055c4c72d",
    x1: 96.32,
    y1: 13.43,
    x2: 96.32,
    y2: 406.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdbdbd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d2cd6e68-7dbd-4df1-94bb-980d7ded7018",
    x1: 96.32,
    y1: 11.67,
    x2: 96.32,
    y2: 89.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "251fa978-0940-41b7-aa2e-7cea80ea9383",
    x1: 96.32,
    y1: 25.48,
    x2: 96.32,
    y2: 72.46,
    xlinkHref: "#d2cd6e68-7dbd-4df1-94bb-980d7ded7018"
  })), /*#__PURE__*/React.createElement("title", null, "face-recognition-hi-dark"), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "977193d8-bb87-4ba4-8e13-9d0b900c43d7",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,56a4,4,0,0,1-4-4V28a4,4,0,0,1,4-4H52a4,4,0,0,1,0,8H32V52A4,4,0,0,1,28,56Z",
    transform: "translate(0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,53.67a4,4,0,0,1-4-4V52a4,4,0,0,0,8,0V49.67A4,4,0,0,1,28,53.67Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,29.67H32V32H52a4,4,0,0,0,4-4,4.09,4.09,0,0,0-.19-1.17A4,4,0,0,1,52,29.67Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52,168H28a4,4,0,0,1-4-4V140a4,4,0,0,1,8,0v20H52a4,4,0,0,1,0,8Z",
    transform: "translate(0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,165.83H28a4,4,0,0,1-4-4V164a4,4,0,0,0,4,4H52a4,4,0,0,0,4-4,3.81,3.81,0,0,0-.17-1.08A4,4,0,0,1,52,165.83Z",
    transform: "translate(0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,56a4,4,0,0,1-4-4V32H140a4,4,0,0,1,0-8h24a4,4,0,0,1,4,4V52A4,4,0,0,1,164,56Z",
    transform: "translate(0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164,53.67a4,4,0,0,0,4-4V52a4,4,0,0,1-8,0V49.67A4,4,0,0,0,164,53.67Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,29.67h20V32H140a4,4,0,0,1-4-4,4.09,4.09,0,0,1,.19-1.17A4,4,0,0,0,140,29.67Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164,168H140a4,4,0,0,1,0-8h20V140a4,4,0,0,1,8,0v24A4,4,0,0,1,164,168Z",
    transform: "translate(0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,165.83h24a4,4,0,0,0,4-4V164a4,4,0,0,1-4,4H140a4,4,0,0,1-4-4,3.81,3.81,0,0,1,.17-1.08A4,4,0,0,0,140,165.83Z",
    transform: "translate(0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.36,106.69s1.74,10.69,1.74,15.59-2.26,7.57-5.73,9.05-20.46,8.46-20.46,8.46,45.28,27.47,89.06,0c0,0-17-7-20.47-8.46s-5.72-4.15-5.72-9.05,1.74-15.59,1.74-15.59Z",
    transform: "translate(0)",
    fill: "url(#7725295b-51bf-4e2f-9b1d-aaa4c3983088)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.77,139l-1.86.76s45.28,27.47,89.06,0l-1.77-.72C101.2,161.61,62.57,143.7,53.77,139Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.15,49.17c3,7,3.49,16,2,23,5.11.34,2.73,11.47-1.25,17.56-1.52,2.33-3.16,2.59-4.49,2.44C120,109.85,106.4,120,96.32,120S72.65,109.85,71.21,92.16c-1.33.15-3-.11-4.5-2.43-4-6.1-6.36-17.23-1.25-17.57-1.46-7-1-16,2-23,0,0,6.29-17.17,28.82-17.17S125.15,49.17,125.15,49.17Z",
    transform: "translate(0)",
    fill: "url(#f1c81ed0-752c-4f39-89b6-2ac055c4c72d)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.83,74.6c.12,3.87-1.7,9.52-4.13,13.26-1.5,2.33-3.13,2.59-4.45,2.44-1.44,17.69-14.93,27.84-24.93,27.84S72.83,108,71.4,90.3c-1.32.15-3-.11-4.46-2.44-2.43-3.74-4.25-9.39-4.12-13.26-1,3.69,1,10.72,3.89,15.13,1.52,2.32,3.17,2.58,4.49,2.43,1.45,17.69,15,27.84,25.12,27.84S120,109.85,121.44,92.16c1.33.15,3-.11,4.49-2.44C128.8,85.32,130.84,78.29,129.83,74.6Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.14,49.17S118.84,32,96.31,32,67.49,49.17,67.49,49.17c-3,7-3.47,16-2,23,1.9-.4,6.31-2.18,6.38-10.08.08-10.06,6-15.1,13.7-12.58a33.91,33.91,0,0,0,21.2,0c7.7-2.57,13.61,2.52,13.7,12.58.07,8.46,5.12,9.9,6.73,10.15C128.63,65.26,128.16,56.13,125.14,49.17Z",
    transform: "translate(0)",
    fill: "url(#d2cd6e68-7dbd-4df1-94bb-980d7ded7018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,62.13c.09-10.06,6-15.1,13.7-12.58a33.91,33.91,0,0,0,21.2,0c7.7-2.57,13.62,2.52,13.7,12.58V60.72c-.08-11.45-5.58-16.1-13.7-14.33a47.91,47.91,0,0,1-21.2,0C78,45,72.11,49.27,72,60.72Z",
    transform: "translate(0)",
    opacity: 0.38,
    fill: "url(#251fa978-0940-41b7-aa2e-7cea80ea9383)",
    style: {
      mixBlendMode: "multiply"
    }
  }))));
}

var _default = ic_face__recognition__dark;
exports.default = _default;